import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutWrapper from '../components/LayoutWrapper';
import {
  CalendarIcon,
  UserPlusIcon,
  UsersIcon,
  ChartBarIcon,
  CogIcon
} from '@heroicons/react/24/outline';
import config from "../config";
import Helper from "../helpers";
const baseUrl = config.apiBaseUrl;

const AdminHome = () => {
  const navigate = useNavigate();
  const [key, setKey] = useState("");

  useEffect(() => {
    //get teh key from local storage
    localStorage.key("");
  }, []);

  const handleSubmit = async () => {
    const token = await Helper.getCookie('wh-jwt');
    //X-admin-exchange-key: {key}
    fetch(`${baseUrl}/api/admin/merchants`, {
      method: 'GET',
      headers: {
        'X-admin-exchange-key': key,
        'Authorization': `Bearer ${token}`
      }
    }).then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Failed ');
        }
    ).then(data => {
      console.log('Success:', data);
    }).catch(error => {
      console.error('Error:', error);
    });
  }

  return (
    <LayoutWrapper
      title="Admin Dashboard"
      subtitle="Overview of your venue's activity and metrics"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {/* Stats Cards */}
        <div className="card p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <CalendarIcon className="h-5 w-5 text-white" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-300">Upcoming Sessions</p>
              <p className="text-2xl font-semibold text-white">12</p>
            </div>
          </div>
        </div>

        <div className="card p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center">
                <UserPlusIcon className="h-5 w-5 text-white" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-300">New Members</p>
              <p className="text-2xl font-semibold text-white">5</p>
            </div>
          </div>
        </div>

        <div className="card p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center">
                <UsersIcon className="h-5 w-5 text-white" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-300">Total Members</p>
              <p className="text-2xl font-semibold text-white">148</p>
            </div>
          </div>
        </div>

        <div className="card p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center">
                <ChartBarIcon className="h-5 w-5 text-white" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-300">Total Bookings</p>
              <p className="text-2xl font-semibold text-white">89</p>
            </div>
          </div>
        </div>
      </div>

      {/* Admin Key Section */}
      <div className="card p-6 mb-8">
        <div className="flex items-center mb-4">
          <CogIcon className="h-6 w-6 text-gray-400 mr-2" />
          <h3 className="text-lg font-semibold text-white">Admin Access</h3>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <input
            type="text"
            placeholder="Enter unlock key..."
            value={key}
            onChange={(e) => setKey(e.target.value)}
            className="input-field flex-1"
          />
          <button
            onClick={handleSubmit}
            className="btn-primary"
          >
            Unlock Admin Features
          </button>
        </div>
      </div>

      {/* Main Content Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6">
          <h3 className="text-lg font-semibold text-white mb-4">
            Recent Activity
          </h3>
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <span className="text-sm text-gray-300">
                New member joined: John Smith
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <span className="text-sm text-gray-300">
                Session booked: Yoga Class
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
              <span className="text-sm text-gray-600 dark:text-gray-400">
                Payment received: £45.00
              </span>
            </div>
          </div>
        </div>

        <div className="card p-6">
          <h3 className="text-lg font-semibold text-white mb-4">
            Quick Actions
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <button className="btn-primary text-center">
              Add Session
            </button>
            <button className="btn-outline text-center">
              Manage Users
            </button>
            <button
              onClick={() => navigate('/admin-reports')}
              className="btn-secondary text-center"
            >
              View Reports
            </button>
            <button className="btn-outline text-center">
              Settings
            </button>
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default AdminHome;
